import { Text } from 'react-native'

import { convertLineHeight, convertPercentageToNumber, styled } from '~/utils'

export const Label = styled(Text, theme => {
  return {
    base: {
      fontFamily: theme.fontFamily.semiBold,
      letterSpacing: convertPercentageToNumber(theme.letterSpacingDefault),
      paddingRight: theme.paddingInsetTwopulse,
      backgroundColor: 'transparent',
      color: theme.colorTextNeutralAlternative,
      fontSize: theme.fontSizeThreepulse,
      lineHeight: convertLineHeight(
        theme.fontSizeThreepulse,
        theme.lineHeightMedium
      ),
    },
    variants: {
      hasDisabled: {
        true: {
          color: theme.colorTextNeutralDisabled,
        },
      },
    },
  }
})
